import React from 'react';

const TableComponentsContext = React.createContext();

export default TableComponentsContext;
